// Slice 10 — links internos de la storefront (puro: sin store ni red, para
// poder testearlo). Los wrappers que resuelven la tienda activa viven en
// store-path.ts.
//
// - Toda ruta de la tienda va con el prefijo /s/<orgSlug>: los hijos de
//   <Route path="/s/:orgSlug"> no responden a "/product/x" (eso cae en el
//   redirect legacy al home). Vale para los dos modos: subdominio
//   ({slug}.getkwad.com/s/{slug}) y path (storefront.getkwad.com/s/{slug}).
// - El identificador público del producto es el slug si existe; si no, el id.
//   La API acepta los dos (primero slug, después id, siempre dentro de la org).
//   Nunca sale "null" / "undefined" en un link: sin identificador → catálogo.

export type ProductLinkRef = {
  id?: string | null;
  productId?: string | null;
  slug?: string | null;
};

function cleanIdentifier(value: unknown): string | null {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;
  return trimmed;
}

export function buildStorePathFor(
  orgSlug: string | null | undefined,
  path: string,
): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const slug = cleanIdentifier(orgSlug);
  return slug ? `/s/${slug}${normalized}` : normalized;
}

/** slug → id → null. */
export function productIdentifier(product: ProductLinkRef | null | undefined) {
  if (!product) return null;
  return (
    cleanIdentifier(product.slug) ??
    cleanIdentifier(product.id) ??
    cleanIdentifier(product.productId)
  );
}

export function productPathFor(
  orgSlug: string | null | undefined,
  product: ProductLinkRef | null | undefined,
): string {
  const identifier = productIdentifier(product);
  if (!identifier) return buildStorePathFor(orgSlug, "/tienda");
  return buildStorePathFor(
    orgSlug,
    `/product/${encodeURIComponent(identifier)}`,
  );
}
